"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcSteps = function ArcSteps(_ref) {
  var stepsItems = _ref.stepsItems,
    currentstep = _ref.currentstep,
    size = _ref.size,
    direction = _ref.direction,
    status = _ref.status,
    isProgressDot = _ref.isProgressDot,
    onChange = _ref.onChange,
    type = _ref.type,
    percent = _ref.percent;
  var Step = _lib.Steps.Step;
  return /*#__PURE__*/_react["default"].createElement(_lib.Steps, {
    type: type,
    current: currentstep,
    size: size,
    direction: direction,
    status: status,
    progressDot: isProgressDot,
    onChange: onChange,
    percent: percent
  }, stepsItems.length > 0 && stepsItems.map(function (step) {
    return /*#__PURE__*/_react["default"].createElement(Step, {
      key: step === null || step === void 0 ? void 0 : step.key,
      title: step === null || step === void 0 ? void 0 : step.title,
      description: step === null || step === void 0 ? void 0 : step.description,
      subTitle: step === null || step === void 0 ? void 0 : step.subTitle,
      icon: step === null || step === void 0 ? void 0 : step.icon
    });
  }));
};
var _default = ArcSteps;
exports["default"] = _default;